import '@/scss/style.scss';
//import { fakeBackend } from '@/utils/helpers/fake-backend';

import logger from '@/utils/loggerLocal';
import { createApp } from 'vue';
import VueTablerIcons from 'vue-tabler-icons';
import VueApexCharts from 'vue3-apexcharts';
import 'vue3-carousel/dist/carousel.css';
import { PerfectScrollbarPlugin } from 'vue3-perfect-scrollbar';
import 'vue3-perfect-scrollbar/style.css';
import App from './App.vue';
import { router } from './plugins/router';
//Mock Api data
//import './_mockApis';


import { vMaska } from "maska/vue";

//i18


//ScrollTop
import VueScrollTo from 'vue-scrollto';

//LightBox
import { waitForAuthReadyWithTimeout } from '@/firebase/waitForAuthReady'; // <--- AGGIUNGI QUESTO
import { i18nParams } from '@/i18n';
import { browserLocalPersistence, getAuth, setPersistence } from 'firebase/auth';
import VueEasyLightbox from 'vue-easy-lightbox';
import { createI18n } from 'vue-i18n';
import { VueFire, VueFireAuth } from 'vuefire';
import { ensureAppCheckReady, initializeAppFirebase } from './firebase/firebaseInit';
import GlobalComponents from "./plugins/global-components";
import vuetify from './plugins/vuetify';


const i18n = createI18n( i18nParams )
const app = createApp( App );
app.config.errorHandler = ( err, instance, info ) => {
    console.error( '[Vue errorHandler]', err, info, instance );
};

app.use( GlobalComponents );
app.use( vuetify );
app.use( logger );
app.use( createPinia() ); // 🔁 Spostato prima del router
try
{
    const init = await initializeAppFirebase();
    const firebaseApp = init.firebaseApp;
    const reCaptchaV3ProviderKey = init.reCaptchaV3ProviderKey;

    // Imposta la persistence PRIMA di waitForAuthReady e di login
    const auth = getAuth( firebaseApp );
    await setPersistence( auth, browserLocalPersistence ); // o browserSessionPersistence a seconda della tua scelta


    app.use( VueFire, {
        firebaseApp,
        modules: [
            VueFireAuth(),
            /*VueFireAppCheck( {
                provider: new ReCaptchaV3Provider( reCaptchaV3ProviderKey ),
                debug: import.meta.env.VITE_ISPROD !== 'true',
                isTokenAutoRefreshEnabled: true,
            } ),*/
        ],
    } );

    await waitForAuthReadyWithTimeout(); // ✅ Firebase auth ready
    app.use( router );
    await router.isReady();
    router.afterEach( ( to ) => {
        console.log( '[afterEach] navigated to', to.fullPath, 'name:', to.name );
    } );

    await ensureAppCheckReady();

    app.use( PerfectScrollbarPlugin );
    app.use( VueTablerIcons );
    app.use( i18n );
    app.directive( 'mask', vMaska );
    app.component( 'apexchart', VueApexCharts );
    app.use( VueScrollTo, { duration: 1000, easing: 'ease' } );
    app.use( VueEasyLightbox );
    //console.log( "👀 Vue dovrebbe essere visibile dopo questo..." );
    app.mount( '#app' );

    //console.log( "🔥 App montata correttamente" );
} catch ( err )
{
    // logga e mostra un fallback visibile
    console.error( 'Bootstrap error', err );
    const el = document.getElementById( 'app' );
    if ( el )
    {
        el.innerHTML = '<div style="padding:16px;font-family:sans-serif">Errore di inizializzazione. Controlla la console.</div>';
    }
}